export const formatCategory = (item: IResponseCategory): IModelCategory => ({
  id: item._id,
  archived: item.archived,
  title: item.title || "NO TITLE",
  bannerUrl: item.content?.PosterF || "",
  imageUrl: item.content?.PosterH || "",
});

export const formatSubCategory = (item: IResponseCategory): IModelSubCategory => ({
  id: item._id,
  archived: item.archived,
  title: item.title || "NO TITLE",
  imageUrl: item.content?.PosterH || "",
  bannerUrl: item.content?.PosterF,
  mainCategories: item.identityId || [],
  facebookUrl: item.socialMediasLinks?.facebook,
  instagramUrl: item.socialMediasLinks?.instagram,
  twitterUrl: item.socialMediasLinks?.twitter,
  webUrl: item.socialMediasLinks?.web,
});

export const formatEventSubCategory = (item: IResponseSubCategory): IModelSubCategory => ({
  id: item._id,
  title: item.title || "NO TITLE",
  imageUrl: item.content?.PosterH || "",
  bannerUrl: item.content?.PosterF,
  mainCategories: item.mediaParentIdentities ? item.mediaParentIdentities.map(formatCategory) : [],
});

export const formatFollowedSubCategory = (identityItem: IResponseFollowedCategoryItem): IModelFollowedSubCategoryItem => {
  const medias = identityItem.medias || [];
  const content = medias[0]?.content || [];
  const imageUrl = content.PosterH || "";

  return {
    id: identityItem.referenceId,
    referenceId: identityItem._id,
    title: medias[0]?.title,
    imageUrl,
    categoryIds: medias[0]?.identityId || [],
    mainCategories: [],
  };
};

export const formatClubList = (categories: IResponseСlubList[]): IModelFavoriteClub[] => {
  const clubList = categories.reduce((result, category) => {
    const subCategories = category.relatedIdentityItems.map(subCategory => ({
      id: `${category._id}|${subCategory._id}`,
      label: subCategory.title,
      categoryTitle: category.title,
    }));
    return [...result, ...subCategories];
  }, [] as IModelFavoriteClub[]);

  return clubList;
};

export const getFavoriteClubIdFromList = (list: IResponseProfileClubList): string | null => {
  if (!list)
    return null;

  const [[key, [value]]] = Object.entries(list);

  return `${key}|${value}`;
};
